export default superclass => class extends superclass  {
    
    attributes = {};
    attributeCallbacks = {};

    newAttribute(name, defaultValue='', callback) {
        this.attributes[name] = defaultValue;
        this.attributeCallbacks[name] = callback;
    }

    setAttribute(name, value) {
        this.attributes[name] = value;
        if (this.attributeCallbacks[name]) {
            this.attributeCallbacks[name](value);
        }
    }
}
